import React from 'react';

const SecurityFeaturePageConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/security',
			exact: true,
			component: React.lazy(() => import('./SecurityFeaturePage')),
		},
	],
};

export default SecurityFeaturePageConfig;
